// Shared by wildfireConfig (frontend) and exportService (backend).

import { caseSqlFromMap } from './lightningTransforms.js';

export const WILDFIRE_STATUS_LABELS: Record<string, string> = {
  OUT_OF_CONTROL: 'Out of Control',
  UNDER_CONTROL: 'Under Control',
  CLOSED: 'Closed',
  BEING_MONITORED: 'Monitored',
  DECLARED_OUT: 'Out',
};

// #771 — response category. Stored on wildfires.response_category_id as a UUID
// FK; operators need the text label in the Explorer grid, filters and exports.
// Same UUID→label pairs the GIS export and the map popups already use.
export const RESPONSE_CATEGORY_LABELS: Record<string, string> = {
  'c61cdf68-8439-404f-b5f0-f0f9c805527c': 'Abandoned',
  '15181fa8-b803-47a8-8ca2-513aa2c6ccd2': 'Being Monitored',
  '2dae2a6e-a00a-490c-b6ee-55c46d972de6': 'Delayed Action',
  '3d43dbc2-8ffc-4dd9-a6b4-cd2b76dd463a': 'Initial Attack',
  '65c9be78-4bd0-42a1-ac7f-f59fcc670df1': 'Limited Action',
  '4629c9a9-6ca8-4268-8cdb-b7c7ff2ea363': 'Sustained Action',
};

// SQL that decodes response_category_id to its label. Shared by the schema
// (grid + export), the router (SELECT / ORDER BY) and the filter builder, so
// all four agree on one expression.
export const RESPONSE_CATEGORY_SQL: string = caseSqlFromMap(
  'response_category_id',
  RESPONSE_CATEGORY_LABELS,
  "'Unknown'",
);
